var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // Vendors


import React from 'react';
import classnames from 'classnames'; // Components

import Container from '../Container/Container';
import ButtonIcon from '../Buttons/ButtonIcon/ButtonIcon';
import { Icon } from '../Icon/Icon'; // Styles

import './alert.scss';

function AlertClose(_a) {
  var onClick = _a.onClick;
  return React.createElement(ButtonIcon, {
    onClick: onClick,
    icon: "x",
    className: "alert-close",
    "aria-label": "Close Alert"
  });
}
/**
 * @visibleName Default
 */


function Alert(_a) {
  var className = _a.className,
      alert = _a.alert,
      handleClose = _a.handleClose,
      props = __rest(_a, ["className", "alert", "handleClose"]);

  var _b = alert.info,
      type = _b.type,
      title = _b.title,
      message = _b.message,
      closeable = _b.closeable;
  return React.createElement(Container, {
    className: classnames('alert-container', className)
  }, React.createElement("div", __assign({}, props, {
    className: classnames('alert', "alert-" + type),
    role: "alert"
  }), React.createElement("div", {
    className: "alert-icon"
  }, React.createElement(Icon, {
    name: "alert-" + type
  })), React.createElement("div", {
    className: "alert-body"
  }, title && React.createElement("h2", {
    className: "alert-title"
  }, title), message && React.createElement("p", {
    className: "alert-message"
  }, message)), closeable && handleClose && React.createElement(AlertClose, {
    onClick: handleClose
  })));
}

export default Alert;